import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Navbar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          sx={{ cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          Movie Night
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Button color="inherit" onClick={() => navigate('/watchlists')}>
          Watchlists
        </Button>
        <Button color="inherit" onClick={() => navigate('/watchlists/new')}>
          Create Watchlist
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 